// extracted by mini-css-extract-plugin
export default {"ElementWrapper":"elementWrapper_ElementWrapper__AiYgp","ElementWrapper__active":"elementWrapper_ElementWrapper__active__E0j2T"};